
import React, { useState } from 'react';
import RedundancyRiskRating from './RedundancyRiskRating';
import RiskAssessmentDialog from './RiskAssessmentDialog';
import { useCompanyRiskData } from '@/hooks/useCompanyRiskData';
import { Review } from '@/lib/types';

interface CompanyRiskAssessmentProps {
  companyName: string;
  reviewCount: number;
  reviews?: Review[]; 
}

const CompanyRiskAssessment = ({ 
  companyName, 
  reviewCount,
  reviews = [] 
}: CompanyRiskAssessmentProps) => {
  const [showFullChart, setShowFullChart] = useState(false);
  
  // Use the extracted hook for data fetching and processing
  const { riskLevel } = useCompanyRiskData({ 
    companyName, 
    reviewCount, 
    reviews 
  });

  const handleExpandChart = () => {
    setShowFullChart(true);
  };
  
  return (
    <>
      <RedundancyRiskRating 
        companyName={companyName}
        riskLevel={riskLevel}
        reviewCount={reviewCount}
      />

      <RiskAssessmentDialog
        showFullChart={showFullChart}
        setShowFullChart={setShowFullChart}
        reviews={reviews}
        onExpandChart={handleExpandChart}
      />
    </>
  );
};

export default CompanyRiskAssessment;
